import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=53049b08&scoped=true&"
import script from "./doctor.vue?vue&type=script&lang=js&"
export * from "./doctor.vue?vue&type=script&lang=js&"
import style0 from "./doctor.vue?vue&type=style&index=0&lang=less&"
import style1 from "./doctor.vue?vue&type=style&index=1&id=53049b08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53049b08",
  null
  
)

export default component.exports